export default __webpack_public_path__ + "static/media/chevron fluted panel.ecf937f7.png";